import { Injectable } from '@angular/core';
import { RepositoryService, UnitOfWorkService } from '@mri/breeze-entity';
import { MetadataStore } from 'breeze-client';
import { ReportActivityRecordInfo } from '../models';
import { reportActivityRecordInfoQueries } from './queries';

@Injectable({ providedIn: 'root' })
export class ReportActivityRecordInfoRepositoryService extends RepositoryService<ReportActivityRecordInfo> {
  constructor(uow: UnitOfWorkService, metadataStore: MetadataStore) {
    super(uow, metadataStore, reportActivityRecordInfoQueries.selectAll);
  }
}
